import { render, staticRenderFns } from "./TopCurators.vue?vue&type=template&id=36f10ca4&scoped=true"
import script from "./TopCurators.vue?vue&type=script&lang=js"
export * from "./TopCurators.vue?vue&type=script&lang=js"
import style0 from "./TopCurators.vue?vue&type=style&index=0&id=36f10ca4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36f10ca4",
  null
  
)

export default component.exports